import { useQuery, useMutation } from "@tanstack/react-query";
import axios from "axios";
import Api from "../Api/Api.json";

// API 1: Send Email
const sendEmailFromSemionbd = async (emailData) => {
  const headers = { headers: { "Content-Type": "application/json" } };
  try {
    const response = await axios.post(Api.EMAIL_SEMIONBD_API, {
      task: "sendEmailFromSemionbd",
      from_email: emailData.from_email,
      to_email_list: emailData.to_email_list,
      subject_text: emailData.subject_text,
      body_text: emailData.body_text
    }, headers);
    return response.data;
  } catch (error) {
    console.error("Error sending email:", error);
    throw error;
  }
};

// API 2: Get Email List for User
const getEmailListForUser = async (userEmailId) => {
  const headers = { headers: { "Content-Type": "application/json" } };
  try {
    const response = await axios.post(Api.EMAIL_SEMIONBD_API, {
      task: "getEmailListForUser",
      user_email_id: userEmailId
    }, headers);
    return response.data;
  } catch (error) {
    console.error("Error fetching email list:", error);
    throw error;
  }
};

// API 3: Get Email Body
const getBodyForEmail = async (userEmailId, timestamp) => {
  console.log("getBodyForEmail called with:", { userEmailId, timestamp });
  const headers = { headers: { "Content-Type": "application/json" } };
  try {
    const requestData = {
      task: "getBodyForEmail",
      user_email_id: userEmailId,
      timestamp: timestamp
    };
    console.log("getBodyForEmail request data:", requestData);
    
    const response = await axios.post(Api.EMAIL_SEMIONBD_API, requestData, headers);
    console.log("getBodyForEmail response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching email body:", error);
    throw error;
  }
};

// Hook for sending email (mutation)
export const useSendEmail = () => {
  return useMutation({
    mutationFn: sendEmailFromSemionbd,
  });
};

// Hook for getting email list
export const useEmailList = (userEmailId, options = {}) => {
  return useQuery({
    queryKey: ["emailList", userEmailId],
    queryFn: () => getEmailListForUser(userEmailId),
    enabled: !!userEmailId,
    ...options,
  });
};

// Hook for getting email body
export const useEmailBody = (userEmailId, timestamp, options = {}) => {
  console.log("useEmailBody hook called with:", { userEmailId, timestamp });
  console.log("useEmailBody enabled:", !!userEmailId && !!timestamp);
  
  // Create a unique key that changes when timestamp changes
  const queryKey = timestamp ? ["emailBody", userEmailId, timestamp] : ["emailBody", userEmailId, "no-timestamp"];
  
  return useQuery({
    queryKey,
    queryFn: () => {
      console.log("useEmailBody queryFn triggered");
      return getBodyForEmail(userEmailId, timestamp);
    },
    enabled: !!userEmailId && !!timestamp,
    staleTime: 0, // Force fresh data
    cacheTime: 0, // Don't cache
    ...options,
  });
};

// Legacy hook for backward compatibility
export const useEmailData = (params, options = {}) => {
  return useQuery({
    queryKey: ["emailData", params],
    queryFn: async () => {
      const headers = { headers: { "Content-Type": "application/json" } };
      const response = await axios.post(Api.EMAIL_SEMIONBD_API, params, headers);
      return response.data;
    },
    enabled: !!params,
    ...options,
  });
};

export default useEmailData;
